import React from 'react';
import Card from '../common/Card';
import { formatDate } from '../../utils/formatters';

/**
 * 검색어를 본문에서 강조 표시
 */
const highlight = (text, keyword) => {
  if (!keyword || !keyword.trim()) return text;
  const safe = keyword.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const parts = String(text).split(new RegExp(`(${safe})`, 'gi'));
  return parts.map((part, i) =>
    part.toLowerCase() === keyword.trim().toLowerCase() ? (
      <mark key={i} className="bg-yellow-200 text-primary-900">
        {part}
      </mark>
    ) : (
      <React.Fragment key={i}>{part}</React.Fragment>
    )
  );
};

/**
 * 작성일 기준 N일 이내면 NEW 표시
 */
const isNew = (createdAt, days = 7) => {
  if (!createdAt) return false;
  const diff = Date.now() - new Date(createdAt).getTime();
  return diff >= 0 && diff <= days * 24 * 60 * 60 * 1000;
};

const NoticeCard = ({ notice, onClick, searchTerm = '' }) => {
  const updated = notice.updatedAt && notice.updatedAt !== notice.createdAt;

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick?.();
    }
  };

  return (
    <Card
      hover
      onClick={onClick}
      className={`transition-all focus:outline-none focus:ring-2 focus:ring-primary-500 ${
        notice.isImportant ? 'border-primary-300 bg-primary-50/40' : ''
      }`}
    >
      <div
        role="button"
        tabIndex={0}
        onKeyDown={handleKeyDown}
        aria-label={`공지사항: ${notice.title}`}
        className="flex items-start justify-between focus:outline-none"
      >
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            {notice.isImportant && (
              <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-primary-100 text-primary-800">
                중요
              </span>
            )}
            <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-accent-100 text-accent-700">
              {notice.category}
            </span>
            {isNew(notice.createdAt) && (
              <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-bold bg-red-100 text-red-700">
                NEW
              </span>
            )}
          </div>
          <h3 className="text-base font-semibold text-primary-900 mb-1 line-clamp-1">
            {highlight(notice.title, searchTerm)}
          </h3>
          <p className="text-sm text-accent-600 line-clamp-2 mb-2">
            {highlight(notice.content, searchTerm)}
          </p>
          <div className="flex items-center gap-3 text-xs text-accent-500">
            <span>{formatDate(notice.createdAt)}</span>
            {updated && <span>(수정됨)</span>}
            <span>조회 {notice.views.toLocaleString()}</span>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default NoticeCard;
